<p>{{ 'help_and_support.payment.paying_in_installments.p1' | translate }}</p>

<p>{{ 'help_and_support.payment.paying_in_installments.p2' | translate }}</p>
<ul>
  <li>{{ 'help_and_support.payment.paying_in_installments.li1' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li2' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li3' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li4' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li5' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li6' | translate }}</li>
  <li>{{ 'help_and_support.payment.paying_in_installments.li7' | translate }}</li>
</ul>

<p>{{ 'help_and_support.payment.paying_in_installments.p3' | translate }}</p>
